// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrderDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class OrderApiClient extends BaseCRUDApiClient<OrderDto> {
  baseUrl = this.config.apiEndpoint + '/order';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
